import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-f7668686"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "userLayout",
  class: /*#__PURE__*/_normalizeClass(['user-layout-wrapper'])
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"top\" data-v-f7668686><div class=\"header\" data-v-f7668686><a href=\"/\" data-v-f7668686><img src=\"" + _imports_0 + "\" class=\"logo\" alt=\"logo\" data-v-f7668686><span class=\"title\" data-v-f7668686>AIMES.NET</span></a></div><div class=\"desc\" data-v-f7668686></div></div>", 1);
const _hoisted_4 = {
  class: "main"
};
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"footer\" data-v-f7668686><div class=\"links\" data-v-f7668686><a href=\"#\" data-v-f7668686>帮助</a><a href=\"#\" data-v-f7668686>隐私</a><a href=\"#\" data-v-f7668686>条款</a></div><div class=\"copyright\" data-v-f7668686> Copyright © 2022 <a target=\"_blank\" href=\"#\" data-v-f7668686>AIMES.NET</a> All rights reserved. v1.0.0 </div></div>", 1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_alert = _resolveComponent("a-alert");
  const _component_a_icon = _resolveComponent("a-icon");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_a_checkbox = _resolveComponent("a-checkbox");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_form = _resolveComponent("a-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_form, {
    class: "user-layout-login"
  }, {
    default: _withCtx(() => [_createVNode(_component_a_tabs, null, {
      default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
        key: "tab1",
        tab: "账号密码登录"
      }, {
        default: _withCtx(() => [_ctx.isLoginError ? (_openBlock(), _createBlock(_component_a_alert, {
          key: 0,
          type: "error",
          showIcon: "",
          style: {
            "margin-bottom": "24px"
          },
          message: _ctx.accountLoginErrMsg
        }, null, 8, ["message"])) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
          name: "account"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            size: "large",
            type: "text",
            placeholder: "账号",
            value: _ctx.logininfo.account,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => _ctx.logininfo.account = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_a_icon, {
              slot: "prefix",
              type: "user",
              style: _normalizeStyle({
                color: 'rgba(0,0,0,.25)'
              })
            }, null, 8, ["style"])]),
            _: 1
          }, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            size: "large",
            type: "password",
            autocomplete: "false",
            placeholder: "密码",
            value: _ctx.logininfo.password,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => _ctx.logininfo.password = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_a_icon, {
              slot: "prefix",
              type: "lock",
              style: _normalizeStyle({
                color: 'rgba(0,0,0,.25)'
              })
            }, null, 8, ["style"])]),
            _: 1
          }, 8, ["value"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_a_form_item, null, {
      default: _withCtx(() => [_createVNode(_component_a_checkbox, null, {
        default: _withCtx(() => [_createTextVNode("自动登录")]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_a_form_item, {
      style: {
        "margin-top": "24px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_a_button, {
        size: "large",
        type: "primary",
        onClick: _withModifiers($setup.onSubmit, ["prevent"]),
        class: "login-button"
      }, {
        default: _withCtx(() => [_createTextVNode(" 确定")]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  })]), _hoisted_5])]);
}